import { createSlice } from '@reduxjs/toolkit';
import { getValidateDni } from '../actions/ValidationDniActions';

const validationDniSlice = createSlice({
  name: 'validationDni',
  initialState: {
    validationStatus: 'idle',
    isValidUser: false,
    status: '',
    messageDniValid: '',
  },
  reducers: {
    resetGet(state) {
      state.validationStatus = 'idle';
      state.isValidUser = false;
      state.status = '';
      state.messageDniValid = '';
    },
    setValidationStatus(state, action) {
      state.validationStatus = action.payload;
    },
    setMessageDniValid(state, action) {
      state.messageDniValid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getValidateDni.pending, (state) => {
        state.validationStatus = 'loading';
        state.isValidUser = false;
      })
      .addCase(getValidateDni.rejected, (state) => {
        state.validationStatus = 'error';
        state.isValidUser = false;
        state.messageDniValid = 'Error al validar DNI.';
      })
      .addCase(getValidateDni.fulfilled, (state, action) => {
        const payload = action.payload;

        if (payload?.tipo === 'error') {
          state.validationStatus = 'error';
          state.isValidUser = false;
          state.messageDniValid = payload?.message || 'Error desconocido';
          state.status = payload?.codigo || '';
          return;
        }
        const isValid = payload?.IndBloqueo === 'NO BLOQUEADO';
        state.validationStatus = 'success';
        state.isValidUser = isValid;
        state.messageDniValid = payload?.message || '';
        state.status = payload?.IndBloqueo || '';
      });
  },
});

export const { resetGet, setValidationStatus, setMessageDniValid } =
  validationDniSlice.actions;
export default validationDniSlice.reducer;
